<template>
  <Fieldset :legend="$t('modal.apiKeys.localStorage')">
    <div class="grid mt-2 grid-cols-1 gap-3">
      <div>
        <IftaLabel>
          <Password type="password" fluid v-model="oneInchApiKey" :feedback="false" toggle-mask>
          </Password>
          <label>{{ $t('modal.apiKeys.apiKey') }}</label>
        </IftaLabel>
      </div>
      <div>
        <IftaLabel>
          <Password type="password" fluid v-model="oneInchPrivateKeyEvm" :feedback="false" toggle-mask>
          </Password>
          <label>{{ $t('modal.apiKeys.privateKeyEvm') }}</label>
        </IftaLabel>
      </div>
      <Button @click="save" severity="secondary" icon="pi pi-save" :label="$t('save')" fluid />
    </div>
  </Fieldset>
</template>

<script lang="ts" setup>
import Password from 'primevue/password';
import IftaLabel from 'primevue/iftalabel';
import Button from 'primevue/button';
import Fieldset from 'primevue/fieldset';
import { computed, onMounted, ref } from 'vue';
import { useMyToast } from '@/composable/useMyToast';
import { i18n } from '@/i18n';
import { useLocalKeys } from "@/composable/useLocalKeys"
import { useWeb3 } from '@/composable/useWeb3'
// import { OneinchV2Service } from '@/services/oneinch-v2-service2'

const { t } = i18n.global
const { addToast } = useMyToast()

const oneInchApiKey = ref<string>()
const oneInchPrivateKeyEvm = ref<string>()

const oneInchKeys = useLocalKeys()

const cacheKeyApi = computed(() => `oneinch-api`)
const cacheKeyEvm = computed(() => `oneinch-key-evm`)

const save = async () => {
  // Validate API key format
  if (!oneInchApiKey.value || oneInchApiKey.value.trim().length < 10) {
    addToast({
      severity: 'error',
      message: t('modal.apiKeys.errors.invalidApiKeyFormat')
    })
    return
  }

  // Validate private key format if provided
  if (oneInchPrivateKeyEvm.value) {
    try {
      const { initWeb3, getPublicKey } = useWeb3()
      initWeb3(['https://rpc.ankr.com/eth'])
      getPublicKey(oneInchPrivateKeyEvm.value)

      // addToast({
      //   severity: 'success',
      //   message: t('modal.apiKeys.saved')
      // })

    } catch (e) {
      console.error(e)
      addToast({
        severity: 'error',
        message: t('modal.apiKeys.errors.invalidPrivateKeyFormat')
      })
      return
    }
  }

  // Verify API key via real request
  // try {
  //   const res = await OneinchV2Service.fetchSpender(oneInchApiKey.value, 1)
  //   if (res.data && 'error' in res.data) {
  //     throw new Error('API key verification failed')
  //   }
  // } catch (e: unknown) {
  //   const msg = e instanceof Error ? e.message : String(e)
  //   addToast({
  //     severity: 'error',
  //     message: `${t('modal.apiKeys.errors.apiKeyVerificationFailed')}: ${msg}`
  //   })
  //   return
  // }

  oneInchKeys.save(cacheKeyApi.value, oneInchApiKey.value)
  oneInchKeys.save(cacheKeyEvm.value, oneInchPrivateKeyEvm.value)
  addToast({
    severity: "success",
    message: t("changesSaved")
  })
}

onMounted(() => {
  oneInchApiKey.value = oneInchKeys.get(cacheKeyApi.value)
  oneInchPrivateKeyEvm.value = oneInchKeys.get(cacheKeyEvm.value)
})
</script>
